import type { CancelReason } from '@lyka-pet-food/contracts'
import { shuffle } from 'lodash'

const OTHER_REASON_SLUG = 'sub-other'

/**
 * Orders cancel reasons for display: shuffles the regular reasons so no single
 * one dominates the top of the list, and pins the catch-all "Other" reason
 * (slug `sub-other`) to the end so it is always presented last.
 */
export const orderCancelReasonsForDisplay = (reasons: CancelReason[]): CancelReason[] => {
  const otherIndex = reasons.findIndex((reason) => reason.slug === OTHER_REASON_SLUG)
  if (otherIndex === -1) return shuffle(reasons)

  const withoutOther = [...reasons.slice(0, otherIndex), ...reasons.slice(otherIndex + 1)]
  return [...shuffle(withoutOther), reasons[otherIndex]!]
}
